import { Railroad, Customer, FieldWorker, JobSummary } from 'src/shared/api';
import { createAction, props } from '@ngrx/store';
import { RailroadDetails } from '../railroad-detail.models';
import { TouchableControl } from 'src/shared/models/TouchableControl';

export const userReportableErrorSavingRailroad = createAction(
	'[Railroads] User Reportable Error While Saving Railroad',
	props<{ message: string }>()
);

export const railroadSaved = createAction(
	'[Railroads] Railroad Saved',
	props<{ railroad: Railroad }>()
);

export const saveRequestedWithInvalidForm = createAction(
	'[Railroads] Save Requested With Invalid Form',
	props<{ controls: TouchableControl[] }>()
);

export const formErrorCleared = createAction('[Railroads] Form Error Cleared');

export const newRailroadSaved = createAction(
	'[Railroads] New Railroad Saved',
	props<{ railroad: Railroad }>()
);

export const errorSavingRailroad = createAction(
	'[Railroads] Error Saving Railroad',
	props<{ error: any }>()
);
export const saveRequested = createAction(
	'[Railroads] Save Requested',
	props<{ shouldStayOnPage: boolean; formValue: RailroadDetails }>()
);

export const railroadDetailDestroyed = createAction(
	'[Railroads] Railroad Detail Destroyed'
);

export const railroadSelected = createAction(
	'[Railroads] Railroad Selected',
	props<{ railroadId: number }>()
);

export const railroadLoadedFromApi = createAction(
	'[Railroads] Railroad Loaded From Api',
	props<{ railroad: Railroad }>()
);

export const railroadLoadedFromStore = createAction(
	'[Railroads] Railroad Loaded From Store',
	props<{ railroad: Railroad }>()
);

export const errorLoadingRailroad = createAction(
	'[Railroads] Error Loading Railroad',
	props<{ error: any }>()
);

export const newRailroadContinued = createAction(
	'[Railroads] New Railroad Continued',
	props<{ railroad: Railroad }>()
);

export const newRailroadStarted = createAction(
	'[Railroads] New Railroad Started'
);

export const customerssLoaded = createAction(
	'[Railroads] Customers Loaded',
	props<{ customers: Customer[] }>()
);

export const rwicsLoaded = createAction(
	'[Railroads] Rwics Loaded',
	props<{ rwics: FieldWorker[] }>()
);

export const jobsLoaded = createAction(
	'[Railroads] Jobs Loaded',
	props<{ jobs: JobSummary[] }>()
);
